import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { HideScrollbar } from '../../global/commonStyle';

const NavbarMain = styled.div`
  width: 210px;
  position: relative;
  display: flex;
  height: 100vh;
  box-orient: vertical;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--background-navbar);
  ${HideScrollbar}
  ${mobile_xl(css`
    width: 100vw;
    background-color: var(--background-secondary);
  `)}
`;

const EmptyDiv = styled.div<{ isNavbarHide?: boolean }>`
  margin-right: var(--space-24);
  ${(props: { isNavbarHide?: boolean }) =>
    props.isNavbarHide &&
    css`
      margin-right: var(--space-6);
    `}
`;

interface ContentProps {
  isTrackingActivity?: boolean;
}

const Content = styled.div<ContentProps>`
  padding-block: var(--space-20) var(--space-64);
  ${(props: ContentProps) =>
    props.isTrackingActivity &&
    css`
      margin-bottom: var(--space-80);
    `}
  ${mobile_xl(css`
    padding: var(--space-24) var(--space-12) var(--space-96);
    p {
      margin: var(--space-0);
      padding-bottom: var(--space-0);
    }
  `)}
`;

const BottomSection = styled.div`
  width: 207px;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: var(--background-navbar);
  padding-bottom: var(--space-6);
`;

export { NavbarMain, EmptyDiv, Content, BottomSection };
